<template>
  <div
    id="downloadBarcodeModal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modelSingle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg" role="document">
      <!--begin::Form-->
      <form class="kt-form" @submit="formSubmit">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ this.$route.meta.breadcrumb }}</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="kt-portlet__body">
              <div class="kt-section kt-section--first">
                <div class="row">
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
                    <div class="form-group">
                      <label class="label">ประเภทสินค้าการถือครอง (วัน):</label>
                      <!-- <select2
                        :css-style="'width: 100%;'"
                        :css-class="'form-control'"
                        :id="'exholProductTypeId'"
                        :name="'exholProductTypeId'"
                        :multiple="true"
                        :select2-options="exholProductTypeIdOptions"
                        v-model="exholProductTypeId"
                      ></select2> -->
                      <treeselect
                        v-model="exholProductTypeId"
                        :multiple="true"
                        :options="exholProductTypeIdOptions"
                        placeholder="กรุณาเลือก"
                      />
                    </div>
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
                    <div class="form-group">
                      <label>ตัวแทนจำหน่าย :</label>
                      <!-- <select2
                        :css-style="'width: 100%;'"
                        :css-class="'form-control m-select2'"
                        :id="'exholAgentCode'"
                        :name="'exholAgentCode'"
                        :multiple="true"
                        :select2-options="exholAgentCodeOptions"
                        v-model="exholAgentCode"
                        ref="exholAgentCodeSelect2"
                      ></select2> -->
                      <treeselect
                        v-model="exholAgentCode"
                        :multiple="true"
                        :options="exholAgentCodeOptions"
                        placeholder="กรุณาเลือก"
                      />
                    </div>
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
                    <div class="form-group">
                      <label>ประเภทร้านค้า :</label>
                      <!-- <select2
                        :css-style="'width: 100%;'"
                        :css-class="'form-control'"
                        :id="'exholShopTypeId'"
                        :name="'exholShopTypeId'"
                        :select2-options="exholShopTypeIdOptions"
                        :multiple="true"
                        v-model="exholShopTypeId"
                        ref="exholShopTypeIdSelect2"
                      ></select2> -->
                      <treeselect
                        v-model="exholShopTypeId"
                        :multiple="true"
                        :options="exholShopTypeIdOptions"
                        placeholder="กรุณาเลือก"
                      />
                    </div>
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
                    <div class="form-group">
                      <label>แบรนด์สินค้า :</label>
                      <!-- <select2
                        :css-style="'width: 100%;'"
                        :css-class="'form-control'"
                        :id="'exholProductBrandId'"
                        :name="'exholProductBrandId'"
                        :select2-options="exholProductBrandIdOptions"
                        :multiple="true"
                        v-model="exholProductBrandId"
                        ref="exholProductBrandIdSelect2"
                      ></select2> -->
                      <treeselect
                        v-model="exholProductBrandId"
                        :multiple="true"
                        :options="exholProductBrandIdOptions"
                        placeholder="กรุณาเลือก"
                      />
                    </div>
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
                    <div class="form-group">
                      <label>ระยะเวลาการถือครอง :</label>
                      <input
                        type="number"
                        id="exholHolderTime"
                        name="exholHolderTime"
                        v-model="exholHolderTime"
                        min="1"
                        class="form-control"
                        placeholder
                      />
                    </div>
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
                    <div class="form-group">
                      <label>สถานะ :</label>
                      <select2
                        :css-style="'width: 100%;'"
                        :css-class="'form-control m-select2'"
                        :id="'exholInActiveStatus'"
                        :name="'exholInActiveStatus'"
                        :select2-options="exholInActiveStatusOptions"
                        v-model="exholInActiveStatus"
                        ref="exholInActiveStatusSelect2"
                      ></select2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              <i class="la la-close"></i> ปิดหน้าต่าง
            </button>
            <button type="submit" class="btn btn-primary">
              <i class="la la-save"></i> Export
            </button>
          </div>
        </div>
      </form>
      <!--end::Form-->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import select2 from "../../../Shared/Select2";
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  components: {
    select2,
    Treeselect,
  },
  data: function() {
    var self = this;
    return {
      exholProductTypeId: [],
      exholAgentCode: [],
      exholShopTypeId: [],
      exholProductBrandId: [],
      exholHolderTime: null,
      exholInActiveStatus: null,
      exholProductTypeIdOptions: [],
      exholAgentCodeOptions: [],
      // exholProductTypeIdOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductType/Select2ProductType",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      // exholAgentCodeOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Agents/Select2SearchAgentName",
      //     type: "post",
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         department: [],
      //         province_id: [],
      //         page: params.page || 1,
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      exholShopTypeIdOptions: [],
      // exholShopTypeIdOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Shop/Select2ShopDistinctShopType",
      //     type: "post",
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      exholProductBrandIdOptions: [],
      // exholProductBrandIdOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductBrand/Select2ProductBrand",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      exholInActiveStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [
          { id: "false", text: "ใช้งาน", data: null },
          { id: "true", text: "ปิดใช้งาน", data: null },
        ],
      },
    };
  },
  methods: {
    formReset() {
      this.exStatus = false;
      $("#exStatus")
        .val(this.exStatus + "")
        .trigger("change");

      this.exYear = null;
      $("#exYear")
        .val(this.exYear + "")
        .trigger("change");

      this.exBudgetType = "";
      $("#exBudgetType")
        .val(this.exBudgetType + "")
        .trigger("change");
    },
    formSubmit: function(e) {
      var self = this;
      let router = this.$router;

      e.preventDefault();

      if (
        !$("#downloadBarcodeModal form")
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/ProductHolder/Export",
        responseType: "arraybuffer",
        data: {
          ProductTypeId: self.exholProductTypeId,
          AgentCode: self.exholAgentCode,
          ShopTypeId: self.exholShopTypeId,
          ProductBrandId: self.exholProductBrandId,
          HolderTime: self.exholHolderTime,
          ActiveStatus: self.exholInActiveStatus,
        },
      })
        .then(function(response) {
          let filename = "";
          let contentType = response.headers["content-type"];
          let disposition = response.headers["content-disposition"];

          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          //Save file
          let blob = new Blob([response.data], { type: contentType });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          //self.formReset();
          KTApp.unblockPage();
        });
    },
    LoadexholProductTypeIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductType/Select2ProductType", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.exholProductTypeIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadexholAgentCodeOptions: function(e) {
      var self = this;
      axios
        .post("/Api/Agents/Select2SearchAgentName", {
          page: 1,
          all: true,
          department: [],
          province_id: [],
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.exholAgentCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadexholShopTypeIdOptions: function(e) {
      var self = this;
      axios
        .post("/Api/Shop/Select2ShopDistinctShopType", {
          page: 1,
          all: true,
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.exholShopTypeIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadexholProductBrandIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductBrand/Select2ProductBrand", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.exholProductBrandIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
  },
  async mounted() {
    let self = this;
    let router = this.$router;

    self.LoadexholProductTypeIdOptions();
    self.LoadexholAgentCodeOptions();
    self.LoadexholShopTypeIdOptions();
    self.LoadexholProductBrandIdOptions();
    //default Active Data
    self.exholInActiveStatus = false;
    $("#exholInActiveStatus")
      .val(self.exholInActiveStatus + "")
      .trigger("change");

    // set validation rules
    $("#downloadBarcodeModal form").validate({
      rules: { DlbRefno: "required" },
      messages: { DlbRefno: "กรุณาเลือกรหัสอ้างอิง" },
    });

    $("#downloadBarcodeModal")
      .on("hidden.bs.modal", function() {
        // Set go back
        router.go(-1);
        self.$parent.reloadDataTable(false);
      })
      .modal("show");
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Master/Holding/HoldingExportModal.vue